import { QueryClient, QueryCache, MutationCache } from "@tanstack/react-query";
import {
  createQueryRetryFunction,
  logQueryError,
} from "@/shared/lib/query-error-handler";

const queryCache = new QueryCache({
  onError: (error, query) => {
    logQueryError(error, { queryKey: query.queryKey });
  },
});

const mutationCache = new MutationCache({
  onError: (error, _variables, _context, mutation) => {
    logQueryError(error, { mutationKey: mutation.options.mutationKey });
  },
});

export const defaultQueryClientOptions = {
  queryCache,
  mutationCache,
  defaultOptions: {
    queries: {
      retry: createQueryRetryFunction(2),
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: createQueryRetryFunction(1),
    },
  },
} satisfies ConstructorParameters<typeof QueryClient>[0];

export const createQueryClient = () =>
  new QueryClient(defaultQueryClientOptions);
